import { mix } from './mix.es.js';
import { noopReturn } from './noop.es.js';
import { fillOffset, defaultOffset } from './offset.es.js';
import { progress } from './progress.es.js';
import { getEasingForSegment } from './easing.es.js';
import { clamp } from './clamp.es.js';
function interpolate(output) {
  var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset(output.length);
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noopReturn;
  var length = output.length;
  /**
   * If the input length is lower than the output we
   * fill the input to match. This currently assumes the input
   * is an animation progress value so is a good candidate for
   * moving outside the function.
   */
  var remainder = length - input.length;
  remainder > 0 && fillOffset(input, remainder);
  return function (t) {
    var i = 0;
    for (; i < length - 2; i++) {
      if (t < input[i + 1]) break;
    }
    var progressInRange = clamp(0, 1, progress(input[i], input[i + 1], t));
    var segmentEasing = getEasingForSegment(easing, i);
    progressInRange = segmentEasing(progressInRange);
    return mix(output[i], output[i + 1], progressInRange);
  };
}
export { interpolate };